import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, CardActions, IconButton, Button, Box, Typography, FormControl, InputLabel, Input, TextField, OutlinedInput, InputAdornment, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper, Checkbox, Select, MenuItem } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Customers from './Customers';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, CheckOutlined, CloseOutlined } from '@mui/icons-material';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    customer_lead_id: string;
    customer_lead_details: any;
    editCustomerName: boolean;
    route: any;
    routes: any;
}

class CustomerLeadDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            customer_lead_id: this.props.match.params.id,
            customer_lead_details: {},
            editCustomerName: false,
            route: 0,
            routes: []
        }
    }

    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.setState({
            customer_lead_details: {
                "id": 163,
                "name": "gfvfe",
                "phone": "452553253255",
                "house_no": null,
                "community": "gef",
                "locality": null,
                "city": "fdvsd",
                "state": null,
                "pincode": "43223",
                "created_at": "2022-03-24 12:57:18",
                "updated_at": "2022-03-24 12:57:18",
                "desa_name": "1",
                "dusun_name": "Biaung Asri",
                "account_type": "Household",
                "is_your_household_part_of_compound": null,
                "no_of_bedrooms": 1,
                "email": null,
                "status": "pending",
                "mrf_id": null,
                "whatsapp_number": null,
                "medium_of_contact": null,
                "reason": null,
                "have_you_contacted_customer_to_new_leads": false,
                "password": null,
                "security_question": null,
                "security_answer": null
            },
            routes: [
                {
                    "id": 90,
                    "name": "Payment Report Test",
                    "type": "Large Generator"
                },
                {
                    "id": 55,
                    "name": "Big Gen",
                    "type": "Large Generator"
                },
                {
                    "id": 54,
                    "name": "WR Supratman New",
                    "type": "Small Generator"
                },
                {
                    "id": 47,
                    "name": "Tangtu",
                    "type": "Small Generator"
                },
                {
                    "id": 46,
                    "name": "Kesambi",
                    "type": "Small Generator"
                },
                {
                    "id": 45,
                    "name": "Kertajiwa",
                    "type": "Small Generator"
                },
                {
                    "id": 44,
                    "name": "Biaung",
                    "type": "Large Generator"
                },
                {
                    "id": 43,
                    "name": "Biaung Asri",
                    "type": "Small Generator"
                },
                {
                    "id": 15,
                    "name": "Pak Fino",
                    "type": "Small Generator"
                },
                {
                    "id": 9,
                    "name": "Pak Batu",
                    "type": "Small Generator"
                },
                {
                    "id": 7,
                    "name": "Kadek",
                    "type": "Small Generator"
                },
                {
                    "id": 6,
                    "name": "Pak Kolok",
                    "type": "Small Generator"
                },
                {
                    "id": 5,
                    "name": "Dummy Route",
                    "type": "Small Generator"
                },
                {
                    "id": 4,
                    "name": "Pak Tomo",
                    "type": "Small Generator"
                },
                {
                    "id": 3,
                    "name": "Demo 1",
                    "type": "Large Generator"
                },
                {
                    "id": 2,
                    "name": "Test route 1 22.04",
                    "type": "Small Generator"
                },
                {
                    "id": 1,
                    "name": "Demo",
                    "type": "Large Generator"
                }
            ]
        })
    }

    public handleRouteChange = (event: any) => {
        this.setState({ route: event.target.value as string });
    };

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        return (
            <div>
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                avatar={
                                    <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/neighbourhood/customer-leads'}><KeyboardArrowLeftRounded /></Button>
                                }
                                title="Customer Lead Details"
                                className="text-left"
                            />
                            <CardContent>
                                <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableBody className="customCardDetails">
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Customer Name
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.name}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Jalan
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.community}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Kota
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.city}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Kodepos
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.pincode}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Phone
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.phone}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Email
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.email}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Desa
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.desa_name}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Dusun
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.dusun_name}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Account Type
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.account_type}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Is Your HouseHold Part Of Compound
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.is_your_household_part_of_compound}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        No of Bedrooms
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>{this.state.customer_lead_details.no_of_bedrooms}</TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Billing Amount
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <TextField id="billing-amounr" label="Billing Amount" variant="outlined" fullWidth={true} />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Have You Contacted Customer
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        MRF Customer ID
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <TextField id="billing-amounr" label="MRF Customer ID" variant="outlined" fullWidth={true} />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="customer-name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        Route
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={this.state.route}
                                                        label="Route"
                                                        onChange={(e: any) => this.handleRouteChange(e)}
                                                        fullWidth={true}
                                                    >
                                                        <MenuItem value="0" selected={true}>Select Route</MenuItem>
                                                        {
                                                            this.state.routes.map((route: any) => {
                                                                return (
                                                                    <MenuItem value={route.id}>{route.name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                            <CardActions sx={{ justifyContent: 'center' }}>
                                <Button variant='contained'>Make Customer</Button>
                                <Button variant='contained' color='error'>Reject Customer</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(CustomerLeadDetails))